import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Content = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Content and Intellectual Property</h3>

      <h4>Ownership</h4>

      <p>
        Unless otherwise stated, the content and materials made available by
        Yoda Safety Services through our website, training platform, and
        services are owned by, licensed to, or used with permission by Yoda
        Safety Services and are protected by applicable intellectual property
        laws.
      </p>

      <p>
        This may include course content, training materials, presentations,
        documents, graphics, text, quizzes, assessments, questions and answers,
        certificates, forms, templates, safety manuals, downloadable resources,
        website content, platform content, and other materials provided through
        our services.
      </p>

      <p>
        Access to or purchase of our services does not transfer ownership of
        Yoda Safety Services content or intellectual property to the user.
      </p>

      <h4>Permitted Use</h4>

      <p>
        Subject to these Terms & Conditions and any applicable service
        agreement, Yoda Safety Services grants authorized users a limited,
        non-exclusive, non-transferable right to access and use applicable
        content and services for their intended personal, workplace, training,
        safety, or internal business purposes.
      </p>

      <p>
        Companies and organizations may use materials made available to them for
        their authorized workplace safety and training purposes where such use
        is included in the applicable service, subscription, purchase, or
        agreement. This permission does not transfer ownership of the underlying
        materials or permit their resale or unauthorized distribution.
      </p>

      <h4>Course Materials, Quizzes, and Assessments</h4>

      <p>
        Course materials, quiz questions, assessment materials, answers, and
        other training content are intended for use by authorized users
        participating in or administering applicable training.
      </p>

      <p>
        Users must not copy, reproduce, publish, distribute, sell, modify,
        disclose, or otherwise make course materials, quiz questions, assessment
        content, or answers available to unauthorized individuals except where
        Yoda Safety Services has provided written permission or where otherwise
        permitted by law.
      </p>

      <h4>Certificates</h4>

      <p>
        Certificates of completion may be issued to users who successfully
        satisfy the applicable course requirements. Certificates may be
        downloaded, retained, displayed, and shared for legitimate purposes,
        including with employers, prospective employers, contractors, clients,
        worksites, or other organizations that reasonably require evidence of
        training or course completion.
      </p>

      <p>
        Certificates must not be altered, falsified, fraudulently reproduced,
        transferred to another individual, or used in a manner that
        misrepresents the holder&apos;s identity, training, completion status,
        qualifications, or results.
      </p>

      <h4>Safety Forms, Manuals, and Documentation</h4>

      <p>
        Safety forms, manuals, templates, and other documentation provided by
        Yoda Safety Services may be used only within the scope of the applicable
        purchase, subscription, service, or agreement. Access to these materials
        does not grant users ownership of Yoda Safety Services intellectual
        property.
      </p>

      <p>
        Users and organizations must not resell, commercially redistribute,
        publicly distribute, or make Yoda Safety Services materials available to
        unauthorized third parties unless expressly authorized in writing.
      </p>

      <h4>Customer and User Content</h4>

      <p>
        Users and organizations retain ownership of information, documents,
        files, images, form entries, and other content that they provide or
        submit through the platform, subject to any rights held by other
        parties.
      </p>

      <p>
        By providing or submitting content through the platform, you grant Yoda
        Safety Services permission to host, store, process, reproduce, and
        otherwise use that content only as reasonably necessary to provide,
        operate, maintain, support, and secure the applicable services or as
        otherwise permitted by these Terms, our Privacy Policy, or applicable
        law.
      </p>

      <p>
        Users and organizations are responsible for ensuring that they have the
        necessary rights, permissions, and authority to upload, submit, or
        otherwise provide content through the platform.
      </p>

      <h4>Restrictions</h4>

      <p>
        Except where expressly permitted by Yoda Safety Services, an applicable
        agreement, or applicable law, users may not copy, reproduce, modify,
        republish, distribute, sell, sublicense, commercially exploit, or create
        derivative works from Yoda Safety Services content or intellectual
        property.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Content;
